require('paroller.js');

export const homeParallax = () => {
    $(".first-element").paroller({ factor: 0.1, factorXs: 0.1, factorSm: 0.1, type: 'foreground', direction: 'vertical' });
    $(".second-element").paroller({ factor: 0.2, factorXs: 0.2, factorSm: 0.1, type: 'foreground', direction: 'vertical' });
    $(".property-element").paroller({ factor: 0.1, factorXs: 0.1, factorSm: 0.1, type: 'foreground', direction: 'vertical' });



}
